import { Plugin } from 'vue'
import { install } from './plugin'
export { useModalBox } from './modalBox';
export type { ModalBoxPluginOptions } from './types';

export default {
    install,
} as Plugin
